import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'ps-ui-custom-tooltip',
  styleUrls: ['./custom-tooltip.component.css'],
  template: `
    <span class="tooltip-container tooltip-{{ direction }}-direction">
      <ng-content
        select="[psUiTooltipTarget], ps-ui-tooltip-target"
      ></ng-content>
      <ng-content
        select="[psUiTooltipContent], ps-ui-tooltip-target"
      ></ng-content>
    </span>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomTooltipComponent {
  @Input()
  public direction: 'left' | 'right' = 'left';
}
